// Import Core
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

// import Plugins
import './plugins'
import './plugins/progress-bar'
import './plugins/lazyload'
import './plugins/validation'
import './plugins/antdesign'
import i18n from './plugins/i18n'
import VueToast from 'vue-toast-notification'
// import filter
import './utils/filters'
import './mixins/global.mixin'
import 'vue-toast-notification/dist/theme-sugar.css'
import * as VueGoogleMaps from 'vue2-google-maps'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faBookOpen, faMapMarkedAlt, faMoneyBillAlt, faHistory, faUsersCog, faListUl, faRoad, faCogs, faUserCircle, faAngleRight, faUsers, faListAlt, faCertificate, faFileSignature } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

Vue.config.productionTip = false
Vue.use(VueToast)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCDqzkgEKPFrfR65Qz6Ha80cW9bK9nRrMo',
    libraries: 'places',
    region: 'VI',
    language: 'vi'
  }
})

library.add(faBookOpen, faMapMarkedAlt, faMoneyBillAlt, faHistory, faUsersCog, faListUl, faRoad, faCogs, faUserCircle, faAngleRight, faUsers, faListAlt, faCertificate, faFileSignature)

Vue.component('font-awesome-icon', FontAwesomeIcon)

const firebaseConfig = {
  apiKey: 'AIzaSyBQMkpWePHwZGpjNfYWQ5KBHMHyAt8fp3Y',
  authDomain: 'donava-2ffb7.firebaseapp.com',
  projectId: 'donava-2ffb7',
  storageBucket: 'donava-2ffb7.appspot.com',
  messagingSenderId: '872512566176',
  appId: '1:872512566176:web:abf4d0b78b432a3ff52ac5',
  measurementId: 'G-CZNDSB1955'
}
// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}
/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n: i18n, // language
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js